import $ from 'jquery'
import { createApp, defineAsyncComponent, h } from 'vue'

import App from '@/App.vue'
import icons from '@/icons'
import i18n, { loadLocaleMessages, locale, setLocale } from '@/plugins/i18n'
import pinia from '@/plugins/pinia'
import initSentry from '@/plugins/sentry'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import { registriereChunkLadefehlerReload } from '@/utils/chunkLadefehler'
import logging from '@/utils/logging'

import '@/assets/main.css'
import '@fontsource/roboto/latin.css'

const app = createApp({
  render: () => h(App)
})

// Global Vue Properties
app.config.globalProperties.$icons = icons

// Globale Installation von JQuery damit Kendo-UI funktioniert
declare global {
  interface Window {
    jQuery: JQueryStatic
    $: JQueryStatic
  }
}
window['jQuery'] = $
window['$'] = $

// Plugin-Installation
app.use(pinia)
app.use(i18n)
app.use(router)
app.use(vuetify)

initSentry(app, router)
registriereChunkLadefehlerReload()

// Registrierung globale Components
app.component('BaseForm', defineAsyncComponent(() => import('@/base/form/BaseForm.vue')))
app.component('DefaultCards', defineAsyncComponent(() => import('@/base/cards/DefaultCards.vue')))

async function startApp(): Promise<void> {
  // Locale und initiale Routen-Chunks parallel laden, damit beide Downloads vor dem Mount abgeschlossen sein können.
  loadLocaleMessages(locale.value).catch((error) => logging.error(error))

  try {
    await router.isReady()
    const routeLocale = router.currentRoute.value.query.lang
    await setLocale(typeof routeLocale === 'string' ? routeLocale : locale.value)
  } catch (error) {
    logging.error(error)
  } finally {
    app.mount('#app')
  }
}

void startApp()

export default app
